import { type FormEvent, type KeyboardEvent, useState } from "react";

export function Composer({
  disabled,
  onSend,
  pending,
}: {
  disabled: boolean;
  onSend: (text: string) => Promise<boolean>;
  pending: boolean;
}) {
  const [text, setText] = useState("");

  async function send(): Promise<void> {
    const message = text.trim();
    if (message.length === 0 || pending || disabled) return;
    const accepted = await onSend(message);
    if (accepted) setText("");
  }

  function submit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    void send();
  }

  function handleKeyDown(event: KeyboardEvent<HTMLTextAreaElement>): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      void send();
    }
  }

  return (
    <form className="composer" onSubmit={submit}>
      <label className="sr-only" htmlFor="fan-message">Message as fan</label>
      <textarea
        id="fan-message"
        rows={1}
        maxLength={10_000}
        value={text}
        onChange={(event) => setText(event.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled || pending}
        placeholder="Message as fan…"
        aria-describedby="composer-flow-note"
      />
      <button
        className="send-button"
        type="submit"
        disabled={disabled || pending || text.trim().length === 0}
        aria-label="Send message through platform"
      >
        <span aria-hidden="true">{pending ? "…" : "↑"}</span>
      </button>
      <p id="composer-flow-note" className="composer-note">
        {pending ? "Sending through the platform flow…" : "Enter to send · Shift+Enter for a new line"}
      </p>
    </form>
  );
}
